module.exports = __webpack_public_path__ + "img/_88A4304.21b8e0b9.jpg";